import { Link } from '@framework/ui/core/router/TypedRoute.tsx';
import { type ComponentProps } from 'react';
import Markdown, { type Components } from 'react-markdown';

const INTERNAL_LINK_PREFIX = 'INTERNAL_LINK';

interface Props {
  message?: string | null;
}

const COMPONENTS: Components = {
  a: ({ children, href }) => {
    if (!href) {
      return children;
    }
    if (href.startsWith(INTERNAL_LINK_PREFIX)) {
      const to = href.replace(
        new RegExp(`^${INTERNAL_LINK_PREFIX}`),
        '',
      ) as unknown as ComponentProps<typeof Link>['to'];
      return <Link to={to}>{children}</Link>;
    }
    return (
      <a target="_blank" rel="noopener noreferrer" href={href}>
        {children}
      </a>
    );
  },
};

export function NotificationMessage(props: Props) {
  const { message } = props;

  if (message == null) return null;

  return (
    <Markdown
      allowedElements={['a', 'strong', 'p', 'em']}
      components={COMPONENTS}
    >
      {message}
    </Markdown>
  );
}
